/** Stops retired actions after a fade, without stale timers stopping a reused action. */
export class ActionStopScheduler<Action extends { stop(): unknown }> {
  private readonly timers = new Map<Action, ReturnType<typeof setTimeout>>();

  cancel(action: Action): void {
    const timer = this.timers.get(action);
    if (timer !== undefined) clearTimeout(timer);
    this.timers.delete(action);
  }

  schedule(action: Action, delayMs: number, isCurrent: () => boolean): void {
    this.cancel(action);
    const timer = setTimeout(() => {
      // A replacement schedule owns its own deadline, even if a stale task runs.
      if (this.timers.get(action) !== timer) return;
      this.timers.delete(action);
      if (!isCurrent()) action.stop();
    }, delayMs);
    this.timers.set(action, timer);
  }

  clear(): void {
    for (const timer of this.timers.values()) clearTimeout(timer);
    this.timers.clear();
  }
}
